import React from 'react'
import { Box, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import type { RelatedPage } from '@/data/research/types'

interface RelatedPagesProps {
  pages: RelatedPage[]
  heading?: string
}

const RelatedPages: React.FC<RelatedPagesProps> = ({
  pages,
  heading = 'Related Pages',
}) => {
  return (
    <Box component="section" sx={{ my: 4 }}>
      <Typography
        variant="h2"
        sx={{ mb: 3, fontSize: { xs: '1.35rem', md: '2.5rem' } }}
      >
        {heading}
      </Typography>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
          gap: 2,
        }}
      >
        {pages.map(page => (
          <Box
            key={page.path}
            component={Link}
            to={page.path}
            sx={{
              p: 2,
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: 1,
              textDecoration: 'none',
              color: 'inherit',
              '&:hover': {
                bgcolor: 'action.hover',
                borderColor: 'primary.main',
              },
            }}
          >
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 600, color: 'primary.main', mb: 0.5 }}
            >
              {page.title}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {page.description}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  )
}

export default RelatedPages
